import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { GET_AUTHORIZED_USERS_KEY } from './useAuthorizedUsers.query';

const postDeactivateAuthorizedUser = (id: string) =>
  api.post(API_URL.AUTHORIZED_USERS_DEACTIVATE_BY_ID(id));

const useDeactivateAuthorizedUserQuery = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation(
    (id: string) => postDeactivateAuthorizedUser(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_AUTHORIZED_USERS_KEY] });
      },
    }
  );

  return {
    deactivateAuthorizedUser: mutateAsync,
    isPending,
  };
};

export default useDeactivateAuthorizedUserQuery;
